export class ActivityDetailResultDto {
  name: string;
  value: string;
  valueType: string;
}
